import React from 'react'
import DealSheetIcon from '@material-ui/icons/Description'
import Typography from '@material-ui/core/Typography'
import { FlexDataItem } from 'components/FlexDataView'
import {FormattedMessage} from 'react-intl'

export default props =>
  <FlexDataItem>
    <Typography variant='subtitle1'>
      <DealSheetIcon /><FormattedMessage id="allocation.section.deal" />
    </Typography>
    <dl>
      <dt><FormattedMessage id="allocation.section.deal.name_label" /></dt>
      <dd>{props.allocation.dealSheet.name}</dd>
    </dl>
  </FlexDataItem>